import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useSelector, useDispatch } from "react-redux";
import { price } from '../Helpers';
import { setData } from "../../redux/actions";
import { toast } from 'react-toastify';

function Cart() {
    const [cart, setCart] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let cartRaw = useSelector((state) => state.data?.cart);

    const handleRemoveFromCart = (product) => {
        toast("Product deleted from cart!");
        setCart((prevCart) => {
            //const updatedCart = prevCart.filter((item) => item._id !== product._id && item.color !== product.color && item.size !== product.size);
            const updatedCart = prevCart.filter((item) => {
                return !(item._id === product._id && item.color === product.color && item.size === product.size);
            });
            localStorage.setItem('cart', JSON.stringify(updatedCart));
            dispatch(setData({ cart: JSON.stringify(updatedCart) }));
            return updatedCart;
        });
    };

    useEffect(() => {
        if (cart.length != 0) {
            localStorage.setItem('cart', JSON.stringify(cart));
            dispatch(setData({ cart: JSON.stringify(cart) }));
        }
    }, [cart]);

    useEffect(() => {
        let parsedCart = [];
        if (typeof cartRaw === "string") {
            try {
                parsedCart = JSON.parse(cartRaw);
            } catch (e) {
                console.error("Invalid JSON in cartRaw:", cartRaw);
            }
        }
        setCart(parsedCart);
    }, [cartRaw]);

    return (
        <>
            <div class="breadcrumb-option">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="breadcrumb__links">
                                <Link to="/bazaar"><i class="fa fa-home"></i> Home</Link>
                                <span>Shopping cart</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section class="shop-cart spad">
                <div class="container">
                    {
                        cart && cart.length > 0 ? (
                            <>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="shop__cart__table">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Product</th>
                                                        <th>Price</th>
                                                        <th>Quantity</th>
                                                        <th>Total</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        cart.map((product, index) => (
                                                            <tr>
                                                                <td class="cart__product__item">
                                                                    <img src={product?.images?.[0]} alt={product?.images?.[0]} />
                                                                    <div class="cart__product__item__title">
                                                                        <h6>{product.productName}</h6>
                                                                        {product.color != "" && (<div>Color: {product.color}</div>)}
                                                                        {product.size != "" && (<div>Size: {product.size}</div>)}
                                                                        {/* <div class="rating">
                                                                            <i class="fa fa-star"></i>
                                                                            <i class="fa fa-star"></i>
                                                                            <i class="fa fa-star"></i>
                                                                            <i class="fa fa-star"></i>
                                                                            <i class="fa fa-star"></i>
                                                                        </div> */}
                                                                    </div>
                                                                </td>
                                                                <td class="cart__price">₹{price(product.price, product.discountInPercent)}</td>
                                                                <td class="cart__quantity">
                                                                    <div class="pro-qty">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={product.quantity}
                                                                            onChange={(e) =>
                                                                                setCart(
                                                                                    cart.map((item, i) =>
                                                                                        i === index ? { ...item, quantity: Number(e.target.value) } : item
                                                                                    )
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td class="cart__total">₹{price(product.price, product.discountInPercent) * product.quantity}</td>
                                                                <td class="cart__close" onClick={(e) => handleRemoveFromCart(product)}><span class="icon_close"></span></td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="cart__btn">
                                            <Link to="/bazaar/shop">Continue Shopping</Link>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        {/* <div class="cart__btn update__btn">
                                            <a href="#"><span class="icon_loading"></span> Update cart</a>
                                        </div> */}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="discount__content">
                                            <h6>Discount codes</h6>
                                            <form action="#">
                                                <input type="text" placeholder="Enter your coupon code" />
                                                <button type="submit" class="site-btn">Apply</button>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 offset-lg-2">
                                        <div class="cart__total__procced">
                                            <h6>Cart total</h6>
                                            <ul>
                                                {/* <li>Subtotal <span>$ 750.0</span></li> */}
                                                <li>Total <span>₹{cart.reduce((sum, item) => sum + (parseFloat(price(item.price, item.discountInPercent)) * parseFloat(item.quantity)), 0)}</span></li>
                                            </ul>
                                            <Link to="/bazaar/checkout" class="primary-btn">Proceed to checkout</Link>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="empty-cart-container">
                                <img
                                    src="https://cdn3.iconfinder.com/data/icons/shopping-and-ecommerce-29/90/empty_cart-512.png"
                                    alt="Empty cart"
                                    className="empty-cart-image"
                                />
                                <h2>Your cart is empty</h2>
                                <p>Looks like you haven't added anything yet.</p>
                                <button className="shop-now-button" onClick={() => navigate("/bazaar/shop")}>
                                    Continue Shopping
                                </button>
                            </div>
                        )
                    }
                </div>
            </section>
        </>
    );
}

export default Cart;
